import React, { createContext, Dispatch, JSX, useReducer } from 'react';

export type BreadcrumbType = { text: string; path: string };
export type PostsPerPageType = number;

type GlobalState = {
  breadcrumbs: BreadcrumbType[];
  postsPerPage: PostsPerPageType;
};

type GlobalAction =
  | { type: 'SET_BREADCRUMBS'; payload: BreadcrumbType[] }
  | { type: 'SET_POSTS_PER_PAGE'; payload: PostsPerPageType };

const initialState: GlobalState = {
  breadcrumbs: [],
  postsPerPage: 10,
};

const reducer: React.Reducer<GlobalState, GlobalAction> = (state: GlobalState = initialState, action: GlobalAction) => {
  switch (action.type) {
    case 'SET_BREADCRUMBS': {
      return { ...state, breadcrumbs: action.payload };
    }
    case 'SET_POSTS_PER_PAGE': {
      return { ...state, postsPerPage: action.payload };
    }
    default:
      return state;
  }
};

export const Store = createContext<{
  globalState: GlobalState;
  setGlobalState: Dispatch<GlobalAction>;
}>({
  globalState: initialState,
  setGlobalState: () => null,
});

export const StoreProvider: React.FC<{ children?: React.ReactNode }> = ({ children }): JSX.Element => {
  const [globalState, setGlobalState] = useReducer(reducer, initialState);
  return <Store.Provider value={{ globalState, setGlobalState }}>{children}</Store.Provider>;
};

export default StoreProvider;
